import SkTechApiClient from "./base/SkTechApiClient";
import dayjs, { Dayjs } from 'dayjs';

export type TimeReport = {
  id: string;
  userId: string;
  description: string;
  projectId: string;
  startTime: Dayjs;
  endTime: Dayjs;
  totalTime: string;
}

export default class TimeReportsApiClient extends SkTechApiClient {

  public getAll = async (): Promise<TimeReport[]> => {
    return await this.Get(`/api/ProjectTimeLog`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data.map((el: {
            totalTime: string;
            endTime: string;
            startTime: string;
          }) => {
            return {
              ...el,
              startTime: dayjs.utc(el.startTime).local(),
              endTime: dayjs.utc(el.endTime).local(),
            }
          });
        }
        return false;
      });
  }

public getAllByPeriod = async (startDate: string, endDate: string): Promise<TimeReport[]> => {
    return await this.Get(`/api/ProjectTimeLog/ByPeriod?startDate=${startDate}&endDate=${endDate}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data.map((el: any) => {
            if (el.log) {
              return {
                ...el,
                log: {
                  ...el.log,
                  startTime: el.log.startTime ? dayjs.utc(el.log.startTime).local() : null,
                  endTime: el.log.endTime ? dayjs.utc(el.log.endTime).local() : null,
                  totalTime: el.log.totalTime || null
                }
              };
            } else {
              return {
                ...el,
                startTime: el.startTime ? dayjs.utc(el.startTime).local() : null,
                endTime: el.endTime ? dayjs.utc(el.endTime).local() : null,
                totalTime: el.totalTime || null
              };
            }
          });
        }
        return false;
      });
}

  public deleteById = async (id: string): Promise<any> => {
    return await this.Delete(`/api/ProjectTimeLog?id=${id}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }


  public getById = async (id: string): Promise<any> => {
    return await this.Get(`/api/ProjectTimeLog/${id}`)
      .then(function (response) {
        if (response.status === 200) {
          return { time: dayjs().utc().local() }
        }
        return false;
      });
  }

  public getByUserId = async (id: string): Promise<any> => {
    return await this.tryGet(`/api/ProjectTimeLog/TimeByUser?userId=${id}`)
      .then(function (response) {
        console.log("response.data", response.data);
        if (response?.status === 200) {
          if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
            return {
              ...response.data,
              time: dayjs.utc(response.data.time).local().format('HH:mm:ss'),
            };
          } else if (Array.isArray(response.data)) {
            return response.data.map((log: { startTime: string, endTime: string }) => ({
              ...log,
              startTime: dayjs.utc(log.startTime).local(),
              endTime: dayjs.utc(log.endTime).local()
            }));
          } else {
            console.error("Error: Invalid data format");
            return [];
          }
        }
        return null;
      });
  }
  
  
  

  public getByProjectId = async (userId: string, projectId: string): Promise<any> => {
    return await this.tryGet(`/api/ProjectTimeLog/TimeByUserOnProject?projectId=${projectId}&userId=${userId}`)
      .then(function (response) {
        if (response?.status === 200) {
          return {
            ...response.data,
            startTime: dayjs.utc(response.data.startTime).local(), 
            endTime: dayjs.utc(response.data.endTime).local(), 
            totalTime: dayjs.utc(response.data.totalTime).local(),
          }
        }
        return false;
      });
  }

  public addTime = async (projectId: string, time: string, endTime: string, userId: string, description: string): Promise<any> => {
    return await this.tryPost(`/api/ProjectTimeLog/AddTimeLogging?projectId=${projectId}&time=${time}&endDate=${endTime}&description=${description}&userId=${userId}`)
      .then(function (response) {
        if (response?.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public editTime = async (id: string, data: { [x: string]: string }): Promise<any> => {
    return await this.Patch(`/api/ProjectTimeLog/${id}`,
      data
    )
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public startTimer = async (id: string): Promise<any> => {
    return await this.Get(`/api/ProjectTimeLog/StartTimeLogging?projectId=${id}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public stopTimer = async (id: string, description: string): Promise<any> => {
    return await this.Get(`/api/ProjectTimeLog/StopTimeLogging?projectId=${id}&description=${description}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public deleteTimer = async (id: string): Promise<any> => {
    return await this.Delete(`/api/ProjectTimeLog?id=${id}`)
    .then(function (response) {
      if (response.status === 200) {
        return true;
      }
      return false;
    });
  }

  public getForFinancier = async (): Promise<any> => {
    return await this.Get(`/api/ProjectTimeLog`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data.map((el: any) => {
            return {
              ...el,
              log:{
                ...el.log,
                startTime: dayjs.utc(el.log.startTime).local(),
                endTime: dayjs.utc(el.log.endTime).local(),
              }
            }
          });
        }
        return false;
      });
  }
}